































import { Component, Vue, Watch } from "vue-property-decorator";
import { payByAny } from "@/services/payment/payment_check/payment_check_logic";
import { Getter } from "vuex-class";
import { GETTER_TAB_COIN_STORE_SETTINGS } from "@/store/constants/setting_types";
import {
  getCountDownEndTime,
  showLimitCoinsLogic
} from "@/services/limit_coins/limitCoinsLogic";
import CountDownTime from "@/components/CountDownTime/CountDownTime.vue";
import LocalizeUtil from "@/services/payment/localize";
import { localize_getters } from "@/services/payment/localize/localizeStore";
// import listenNative from "@/jsbridge/service/listenNative";
import AppLifeCycle from "@/utils/app_lifecycle/app_lifecycle";

@Component({
  components: {
    CountDownTime
  }
})
export default class LimitedCoin extends Vue {
  // tab_coin_store数据
  @Getter(GETTER_TAB_COIN_STORE_SETTINGS)
  private tabCoinStore: any;

  private showLimit: boolean = false;
  private intervalTimer: any;
  private endTime: number = 0;
  private nativePrice: string = "";

  // tab_coin_store中limited_coin_offers第一组数据
  get limitedCoinOffers() {
    return this.tabCoinStore && this.tabCoinStore.limited_coin_offers
      ? this.tabCoinStore.limited_coin_offers[0]
      : null;
  }

  get localizeProduct() {
    return localize_getters.products_getter();
  }

  @Watch("localizeProduct", { deep: true, immediate: true })
  private onProductsChange() {
    this.nativePrice = LocalizeUtil.getLocalizePriceByOffer(
      this.limitedCoinOffers
    );
  }

  private _pay() {
    payByAny({ offer: this.limitedCoinOffers });
  }

  private countDownTimeEnded() {
    this.showLimit = false;
    clearInterval(this.intervalTimer);
    this.intervalTimer = null;
    this.countDownTimer(true);
  }

  private countDownTimer(first: boolean) {
    if (!this.intervalTimer) {
      this.intervalTimer = setInterval(() => {
        if (showLimitCoinsLogic(first)) {
          this.showLimit = true;
          this.setEndTime();
          clearInterval(this.intervalTimer);
        }
      }, 1000);
    }
  }

  private setEndTime() {
    if (this.showLimit) {
      this.endTime = getCountDownEndTime();
    }
  }

  private listenForeground() {
    AppLifeCycle.addFrontListener(() => {
      this.showLimit = showLimitCoinsLogic();
    }, "limit_coins");
  }

  private created() {
    this.showLimit = showLimitCoinsLogic(true);
    this.setEndTime();
    this.countDownTimer(!this.showLimit);
    this.listenForeground();
  }

  private beforeDestroy() {
    this.intervalTimer && clearInterval(this.intervalTimer);
    AppLifeCycle.removeListener("limit_coins");
  }

  private activated() {
    this.showLimit = showLimitCoinsLogic();
    this.setEndTime();
    this.countDownTimer(!this.showLimit);
    this.listenForeground();
  }

  private deactivated() {
    this.intervalTimer && clearInterval(this.intervalTimer);
    AppLifeCycle.removeListener("limit_coins");
  }
}
